<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable :overlay="false" max-width="100%" transition="dialog-transition">
      <v-card>
        <v-toolbar color="blue white--text darken-3" flat dense>
          <v-toolbar-title>Visualizacion de reporte</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="fnDescarga" small class="ml-4" @click="fnDescarga">
            <v-icon>mdi-microsoft-excel</v-icon>
            Exportar
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0">
          <iframe :src="base64" v-if="base64" width="100%" height="100%" class="pdf_height"></iframe>
          <!-- <object v-if="base64" :data="base64" width="100%" height="950px" /> -->
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click.prevent="cerrarModal()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'VerPdf',
  props: {
    fnDescarga: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      base64: null,
    };
  },
  components: {},
  watch: {
    dialog(val) {
      if (!val) {
        this.base64 = null;
        this.$emit('cerradoModal');
      }
    },
  },
  methods: {
    async abrir(data) {
      this.dialog = true;
      this.base64 = data;
    },
    cerrarModal() {
      this.dialog = false;
    },
  },
};
</script>

<style>
.pdf_height {
  height: calc(var(--vh, 1vh) * 100 - 12rem);
}
</style>
